import React, { useEffect, useState } from 'react'
import { Text } from '../../../../modules/Dashboard'
import { AnimatePresence, motion } from 'framer-motion'
import { defaultTransition, IMG_SIZE } from './common'
import { VerticalGradient } from './VerticalGradient'
import Spinner from './Spinner'
import { HorizontalGradient } from './HorizontalGradient'
import TickIcon from '../../../../components/icons/TickIcon'
import { PulseLoader } from 'react-spinners'

const ITEMS = [
    { title: 'loading-step-3-item-1' },
    { title: 'loading-step-3-item-2' },
    { title: 'loading-step-3-item-3' },
]

const Step3 = ({ done }) => {
    let itemInterval;
    const [phase, setPhase] = useState("image"); // "image" | "items"
    const [enabledItems, setEnabledItems] = useState([])


    const handleAnimationComplete = (index) => {
        itemInterval = setTimeout(() => {
            setEnabledItems((prev) => [...prev, index])
        }, 2500)
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setPhase("items");
        }, 5000);

        return () => {
            clearTimeout(timer)
            clearTimeout(itemInterval)
        };
    }, []);

    return (
        <>
            {done && (
                <>
                    <VerticalGradient className={"absolute top-0 left-0 !w-[1px] !h-[428px]"} done />
                    <VerticalGradient className={"absolute top-0 right-0 !w-[1px] !h-[428px]"} done />
                </>
            )}
            <div className='absolute top-3 ltr:right-3 rtl:left-3'>
                <Spinner done={done} />
            </div>
            <div className='flex flex-col gap-5 items-start w-full'>
                <motion.div
                    initial={{ x: -500, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={defaultTransition}
                    className='max-w-[250px]'
                >
                    <Text tid={"loading-title-step-3"} className={`text-2xl text-wrap ${done ? "!text-success" : "!text-warn"}`} />
                </motion.div>
                <motion.div
                    initial={{ x: 500, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={defaultTransition}
                    className='mt-2'
                >
                    <Text tid={"loading-desc-step-3"} className='! opacity-90' />
                </motion.div>
                <HorizontalGradient done={done} x={-500} />

                <AnimatePresence mode="wait">
                    {/* Phase rendering */}
                    <motion.div
                        key={phase}
                        initial={{ x: 100, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: -200, opacity: 0 }}
                        transition={{ ...defaultTransition, delay: 0.5 }}
                        className='w-full'
                    >
                        {phase === "image" && (
                            <img
                                src={require('../../assets/loading/fair-value-gap.webp')}
                                alt='FVG'
                                width={IMG_SIZE.width} height={IMG_SIZE.height} className='object-cover rounded-xl'
                            />
                        )}

                        {phase === "items" && (
                            <div className='flex flex-col gap-3 w-full'>
                                {ITEMS.map((item, index) => {
                                    const isEnabled = enabledItems.includes(index);

                                    return (
                                        <motion.div
                                            key={index}
                                            initial={{ opacity: 0, x: index % 2 === 0 ? 250 : -250 }}
                                            animate={{ opacity: 1, x: 0 }}
                                            transition={{ delay: (index + 1) / 0.9, duration: 0.5 }}
                                            onAnimationComplete={() => handleAnimationComplete(index)}
                                            className={`flex md:items-center items-start justify-between gap-3 p-2 w-full rounded-md transition-colors ${isEnabled ? "!bg-[#1D1F23]" : "bg-[#000000]"}`}
                                        >
                                            <Text tid={item.title} className={`text-sm ${isEnabled ? "" : "opacity-60"}`} />
                                            {isEnabled ? (
                                                <div className='flex items-center gap-1'>
                                                    <Text tid="uploaded" className='!text-success text-sm' />
                                                    <span className={`p-1 rounded-md ${isEnabled ? "bg-success" : "bg-[#ACACAC]"}`}>
                                                        <TickIcon size={13} color={isEnabled ? '#fff' : '#666'} />
                                                    </span>
                                                </div>
                                            ) : (
                                                <PulseLoader color='#00c795 ' size={6} speedMultiplier={0.5} />
                                            )}
                                        </motion.div>
                                    );
                                })}
                            </div>
                        )}
                    </motion.div>
                </AnimatePresence>
            </div>
        </>
    )
}

export default Step3
